/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
//Custom libraries
import { CART } from "../../constants/routes";
//Redux
import { numItemsSelector } from "../../redux/selectors/order";
//UI
import { Badge } from "@material-ui/core";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import { StyledGrid } from "../elements";

const MobileMiniCart = () => {
  const numItems = useSelector(numItemsSelector);
  const history = useHistory();

  const goToCart = () => {
    history.push(CART);
  };

  return (
    <StyledGrid item className="container-mobile-cart">
      <Badge
        color="secondary"
        badgeContent={numItems}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        onClick={goToCart}
        className="badge-cart"
        data-testid="mobile-mini-cart-button">
        <ShoppingCartIcon className="iconCarritoMobile" />
      </Badge>
    </StyledGrid>
  );
};

export default MobileMiniCart;
